/**
 * @deprecated use `typeof BaseModel` instead
 */
export type BaseModelType<T extends BaseModel> = {
  new (model?: Partial<T>): T;
  factory<T extends BaseModel>(model?: Partial<T>): T;
  mapModel<T>(model?: Partial<T>): T;
  mapModelOrNull<T>(model?: Partial<T>): T | null;
  mapModels<T>(models?: Partial<T>[]): T[];
  mapModelsOrNull<T>(models?: Partial<T>[]): T[] | null;
};

export class BaseModel {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(model = {}) {}

  static factory<T extends BaseModel>(
    this: new (model?: Partial<T>) => T,
    model: Partial<T> = {}
  ): T {
    model = model ?? {};
    const newModel: T = new this(model);

    return newModel as T;
  }

  static mapModel<T extends BaseModel>(
    this: typeof BaseModel & (new (model?: Partial<T>) => T),
    model?: Partial<T> | null
  ): T {
    return this.factory(model ?? undefined);
  }

  static mapModelOrNull<T extends BaseModel>(
    this: typeof BaseModel & (new (model?: Partial<T>) => T),
    model?: Partial<T> | null
  ): T | null {
    return model ? this.mapModel(model) : null;
  }

  static mapModels<T extends BaseModel>(
    this: typeof BaseModel & (new (model?: Partial<T>) => T),
    models?: Partial<T>[] | null
  ): T[] {
    return models?.length ? models.map((item: BaseModel) => this.mapModel(item)) : [];
  }

  static mapModelsOrNull<T extends BaseModel>(
    this: typeof BaseModel & (new (model?: Partial<T>) => T),
    models?: Partial<T>[] | null
  ): T[] | null {
    if (!models) return null;
    return this.mapModels(models);
  }
}
